import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MiniFlowPlayerService {
    private updateSubject = new Subject<any>();

    passUpdateRequest(request: any): void{
        this.updateSubject.next(request);
    }

    updateComponent(): Observable<any>{
        return this.updateSubject.asObservable();
    }
}
